import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {EXPERT_SYSTEM_KPI_REQUEST_STALE_TIME} from '../consts'
import {CommentKpiValue, CommentsQueryKey, ExpertSystemEquipmentType, YearMonth} from '../types'

export const useCommentKpi = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  hierarchyId: string,
  yearMonth: YearMonth, // YYYY-MM
  day?: number, // day of month; when set only comments of that day are returned
  options?: Omit<UseQueryOptions<CommentKpiValue[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<CommentKpiValue[], AxiosError>({
    queryKey: [CommentsQueryKey, kpiTargetEquipmentType, hierarchyId, yearMonth, day],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<CommentKpiValue[]>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/mtm/${yearMonth}/${hierarchyId}/comments`,
        {params: {day}, signal}
      )
      return response.data
    },
    select: (data) => data?.filter((comment) => !comment.isDeleted) ?? [],
    staleTime: EXPERT_SYSTEM_KPI_REQUEST_STALE_TIME,
    ...options
  })
}
